import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CancelComponent } from '@shared/components';
import { ButtonModule } from '@vg-constellation/angular-16/button';

export interface TaxUploadFaqContent {
  title: string;
  subtitle1: string;
  vanguard: string;
  address1Line1: string;
  address1Line2: string;
  subtitle2: string;
  address2Line1: string;
  address2Line2: string;
}

@Component({
  selector: 'app-tax-upload-faq',
  standalone: true,
  imports: [CommonModule, ButtonModule, CancelComponent],
  templateUrl: './tax-upload-faq.component.html',
  styleUrls: ['./tax-upload-faq.component.scss'],
})
export class TaxUploadFaqComponent {
  @Input() content!: TaxUploadFaqContent;
  @Input() continueButtonLabel!: string;
  @Output() continueClick = new EventEmitter<void>();

  onContinueClick(): void {
    this.continueClick.emit();
  }
}
